import React, { createContext, useContext, useEffect, useState } from 'react';
import { googleLogout } from '@react-oauth/google';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('googleIdToken'));

  useEffect(() => {
    if (token) {
      localStorage.setItem('googleIdToken', token);
    } else {
      localStorage.removeItem('googleIdToken');
    }
  }, [token]);

  const login = (idToken) => setToken(idToken);

  const logout = () => {
    setToken(null);
    // Disable auto select in the Google SDK
    try {
      googleLogout();
    } catch (err) {
      // ignore
    }
  };

  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return ctx;
}

export default AuthContext;
